import { createContext } from 'react'
import type { Context } from 'react'

/**
 * Create a React Context with a default display name
 * to facilitate debugging via React devtools
 * */
export function createNamedContext<T>(
  name: string,
  initialValue: T | null = null
): Context<T | null> {
  const context = createContext(initialValue)
  context.displayName = name

  return context
}
